var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.2 0H1.8C1 0 .3.7.3 1.5v17.1c0 .7.7 1.4 1.5 1.4h8.4c.8 0 1.5-.7 1.5-1.5v-17C11.7.7 11 0 10.2 0M3.9.9h4.2c.1 0 .2.2.2.4s-.1.3-.2.3H3.9c-.1 0-.2-.2-.2-.4s.1-.3.2-.3M6 18.6c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9m4.6-3.2H1.4V2.5h9.1c.1 0 .1 12.9.1 12.9"
  })));
};
export default SvgMobile;